export default __webpack_public_path__ + "images/38e34db764c30bff7b13aa8cc36401ff-st_patricks_day.jpg";